import * as React from 'react';
import "./UserItemContent.scss";
import PermissionBadge from '../../../components/PermissionBadge';
import ListAvatar from '../../../components/ListAvatar';
import { PermissionEnum } from '../../../models';
import { UserData } from '../../../models';

export interface UserItemContentProps {
    user: UserData,
    branchNames?: string[],
}

const UserItemContent: React.FC<UserItemContentProps> = (props) => {
    const { user, branchNames } = props;

    const showPermission = (permission: PermissionEnum, permissions: PermissionEnum[]): boolean => {
        switch(permission) {
            case PermissionEnum.ClientsAccess: return !permissions.includes(PermissionEnum.ClientsManagement);
            case PermissionEnum.PricesAccess: return !permissions.includes(PermissionEnum.PricesManagement);
            case PermissionEnum.AppointmentsAccess: return !permissions.includes(PermissionEnum.AppointmentsManagement);
            default: return permission === PermissionEnum.Administrator || !permissions.includes(PermissionEnum.Administrator);
        }
    };

    return (
        <div className="userItemContent">
            <ListAvatar
                src={user.photoUrl}
                alt={user.name || user.username}
                displayName={user.name || user.username}
                username={user.username}
                email={user.email}
            />
            <div className="userItemContentDetails">
                <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XXS)' }}>
                    <span>{user.name || user.username}</span>
                    {user.name && <span style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{user.username}</span>}
                    {!!branchNames?.length && (
                        <span className="userItemBranches">
                            {branchNames.map(name => (<span key={name} className="userItemBranchChip">{name}</span>))}
                        </span>
                    )}
                </div>
                <span style={{ display: 'flex', gap: 'var(--spacer-XS)', alignItems: 'end', justifyContent: 'flex-end' }}>
                    { user.permissions
                        .filter(p => showPermission(p, user.permissions))
                        .map(p => (<PermissionBadge key={p.toString()} permission={p}/>)) }
                    { !!user.professionalId && <PermissionBadge permission={'Professional'} /> }
                </span>
            </div>
        </div>
    );
}

export default UserItemContent;